import React, { useState } from 'react';
import { Modal, Button, Container } from 'react-bootstrap';
import { formatCurrency } from '../../utils/appUtils';

const CartModal = ({ data }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);

  const openViewModal = (data) => {
    setModalData(data);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalData(null);
  };

  return (
    <>
      <Button className="btn sis-button" variant="none" onClick={() => openViewModal(data)}>
        View Items
      </Button>

      <Modal show={showModal} onHide={closeModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Product Information</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          {modalData ? (
            <>
              <h5 className="mb-3">Items</h5>
              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Product Name</th>
                      <th>Quantity</th>
                      <th>Sale Price</th>
                      <th className='text-end'>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modalData.items.map((item, index) => {
                      const price = parseFloat(item.price); // Convert string to number
                      const quantity = item.quantity;
                      const total = price * quantity;

                      return (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>
                            {item.name}
                            {item.sku && (
                              <p className="text-muted mb-1 text_sm">
                                SKU: {item.sku}
                              </p>
                            )}
                          </td>
                          <td>{quantity}</td>
                          <td>{formatCurrency(price)}</td>
                          <td className='text-end'>{formatCurrency(total)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="4" className="text-end"><strong>Grand Total:</strong></td>
                      <td className='text-end'>
                        <strong>
                          {formatCurrency(modalData.totals.subtotal)}
                        </strong>
                      </td>
                    </tr>
                    {parseFloat(modalData.totals.discount) > 0 &&
                      <tr>
                        <td colSpan="4" className="text-end"><strong>Discount:</strong></td>
                        <td className='text-end'>
                          <strong>
                            - {formatCurrency(modalData.totals.discount)}
                          </strong>
                        </td>
                      </tr>
                    }
                    {parseFloat(modalData.totals.offer) > 0 &&
                      <tr>
                        <td colSpan="4" className="text-end"><strong>Offer:</strong>
                          {modalData.couponCode ? (
                            <span className="text-danger ms-2 text_sm">
                              {`using ${modalData.couponCode}`}
                            </span>
                          ) : null}</td>
                        <td className='text-end'>
                          <strong>
                            - {formatCurrency(modalData.totals.offer)}
                          </strong>
                        </td>
                      </tr>
                    }
                    <tr>
                      <td colSpan="4" className="text-end"><strong>Shipping:</strong></td>
                      <td className='text-end'>
                        <strong>
                          {formatCurrency(modalData.totals.shipping)}
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="4" className="text-end"><strong>Total:</strong></td>
                      <td className='text-end'>
                        <strong>
                          {formatCurrency(modalData.totals.grandTotal)}
                        </strong>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </>
          ) : (
            <p>Loading data...</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CartModal;
